import { ValveType } from 'shared/tools/ValveTypes.ts';

const prefix = 'https://www.belimo.com/mam/europe/pictures-and-graphics/product/water_solutions/';

export const mappingEU: { type: ValveType; image: string }[] = [
    // Pressure independent
    {
        type: 'Pressure-independent Belimo Energy Valve™',
        image: `${prefix}va-units/PIC_EU_EV032R2_MID_4C-product_retina.jpg`,
    },
    {
        type: 'Electronic pressure-independent characterised control valve',
        image: `${prefix}va-units/PIC_EU_EP..R2+BAC_4C-product_retina.jpg`,
    },
    {
        type: 'Pressure-independent 6-way zone valve',
        image: `${prefix}va-units/PIC_EU_EP..R6_BAC-HH1_rendering-product_retina.jpg`,
    },
    {
        type: 'Pressure-independent zone valve',
        image: `${prefix}va-units/PIC_EU_CQ24A-MPL_C215QP-B_4C-product_retina.jpg`,
    },
    {
        type: 'Pressure-independent flow limiter valve',
        image: `${prefix}va-units/PIC_EU_CQK24A_C220QFL-G_4C-product_retina.jpg`,
    },
    // Pressure dependent
    {
        type: '6-way zone valve',
        image: `${prefix}va-units/PIC_EU_NR24A-SR_R3025-6P3-6P3-B3_4C-product_retina.jpg`,
    },
    {
        type: 'Characterised control valve',
        image: `${prefix}va-units/PIC_EU_LR24A-SR_R2025-10-S2_4C-product_retina.jpg`,
    },
    {
        type: 'Globe valve',
        image: `${prefix}va-units/PIC_EU_NV24A-TPC_H725S_4C-product_retina.jpg`,
    },
    {
        type: 'Butterfly valve',
        image: `${prefix}va-units/PIC_EU_PRCA-BAC-S2-T-200_D6200WL_4C-product_retina.jpg`,
    },
    {
        type: 'Zone valve',
        image: `${prefix}va-units/PIC_EU_CQ24A-MPL_C215Q-J_4C-product_retina.jpg`,
    },
    {
        type: 'Potable water valve',
        image: `${prefix}va-units/PIC_EU_LR24A_R220PW-P_4C-product_retina.jpg`,
    },
];

const prefixAM = 'https://www.belimo.com/mam/americas/pictures_and_graphics/products/valve_product_pictures/';
export const mappingAM: { type: ValveType; image: string }[] = [
    // Pressure independent
    {
        type: 'Pressure-independent Belimo Energy Valve™',
        image: `${prefixAM}energy_valve_pictures/belimo_EV-AK_image-product_retina.jpg`,
    },
    {
        type: 'Electronic pressure-independent characterized control valve',
        image: `${prefixAM}epiv_valve_picture/PIC_AM_EP032R2+BAC_thumbnail-product_retina.jpg`,
    },
    {
        type: 'Pressure-independent zone valve',
        image: `${prefixAM}zonetight/2-way_PIQCV-product_retina.jpg`,
    },
    {
        type: 'Pressure-independent flow limiter valve',
        image: `${prefix}va-units/PIC_EU_CQK24A_C220QFL-G_4C-product_retina.jpg`,
    },
    // Pressure dependent
    {
        type: 'Characterized control valve',
        image: `${prefixAM}ccv_valve_pictures/2-Way_Valve-product_retina.jpg`,
    },
    {
        type: 'Ball valve',
        image: `${prefixAM}ball_valve_pictures/BV_VS_Valve1-product_retina.jpg`,
    },
    {
        type: 'Globe valve',
        image: `${prefixAM}globe_valve_pictures/Globe2Valve1.5_2-product_retina.jpg`,
    },
    {
        type: 'Zone valve',
        image: `${prefixAM}zonetight/2-way_QCV-product_retina.jpg`,
    },
    {
        type: 'Butterfly Valve',
        image: `${prefix}Valves/PIC_EU_D6300WL_4C-product_retina.jpg`,
    },
];
